
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { hideToast } from "../../Store/Toast/toastAction";
import "react-toastify/dist/ReactToastify.css";

const Toaster = ({
  defaultConfig = {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  },
}) => {
  const {
    open,
    message,
    type,
    config = {},
  } = useSelector((state) => state.toast);
  const dispatch = useDispatch();
  const toastId = useRef(null);

  useEffect(() => {
    if (open && !toastId.current) {
      const finalConfig = {
        ...defaultConfig,
        ...config,
        onClose: () => {
          toastId.current = null;
          dispatch(hideToast());
        },
        icon: getIcon(type),
        type,
      };

      toastId.current = toast(message, finalConfig);
    }
  }, [open, message, type, config, dispatch, defaultConfig]);

  const getIcon = (type) => {
    switch (type) {
      case "error":
        return <ErrorIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "info":
        return <InfoIcon />;
      case "warning":
        return <WarningIcon />;
      default:
        return null;
    }
  };

  return <ToastContainer closeButton={false} />;
};

export default Toaster;